import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgLoupeSearch32 = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps, ref: Ref<SVGSVGElement>) => <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path d="M14.1674 26.3476C20.8875 26.3476 26.3476 20.9003 26.3476 14.1674C26.3476 7.43462 20.9003 2 14.1674 2C7.43462 2 2 7.44735 2 14.1674C2 20.8875 7.44735 26.3476 14.1802 26.3476H14.1674Z" stroke="currentColor" strokeWidth={1.4} strokeLinecap="square" /><path d="M30.0002 29.9997L22.7837 22.7832" stroke="currentColor" strokeWidth={1.4} strokeLinecap="square" /></svg>;
const ForwardRef = forwardRef(SvgLoupeSearch32);
export default ForwardRef;